import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    borderTop: `1px solid`,
    borderTopColor: theme.palette.grey[600],
    padding: 16,
    paddingBottom: 0,
    marginTop: 16,
    marginLeft: -1 * theme.spacing(2),
    marginRight: -1 * theme.spacing(2)
  },
  list: {
    margin: 0,
    marginTop: 16,
    padding: `0 24px`
  },
  listItem: {
    marginBottom: theme.spacing(1)
  }
}))

const Instructions = ({
  description,
  steps = [],
  ...props
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root} {...props}>
      <Typography variant="overline">
        Instructions
      </Typography>
      {description && (
        <Typography variant="body1">
          {description}
        </Typography>
      )}
      <ol className={classes.list}>
        {steps.map((step, idx) => (
          <li key={idx} className={classes.listItem}>
            <span>{step}</span>
          </li>
        ))}
      </ol>
    </div>
  )
}

Instructions.propTypes = {
  description: PropTypes.string,
  steps: PropTypes.arrayOf(PropTypes.string)
}

export default Instructions
